const fioFieldFormatter = (value, regex) => (value
  ? value
    .toString()
    .replace(new RegExp(regex, 'g'), '')
    .replace(/\s\s+/g, ' ')
  : '');

export default fioFieldFormatter;
